import { NgModule, ModuleWithProviders } from '@angular/core';

import { QueryServiceConfig, QUERY_CONFIG } from './query.config';
import { QueryService } from './query.service';

@NgModule({
  providers: [
    QueryService,
  ],
})
export class QueryModule {

  static forRoot(config: QueryServiceConfig): ModuleWithProviders<QueryModule> {
    return {
      ngModule: QueryModule,
      providers: [
        QueryService,
        {
          provide: QUERY_CONFIG,
          useValue: config,
        },
      ],
    };
  }

  static forChild(config: QueryServiceConfig): ModuleWithProviders<QueryModule> {
    return QueryModule.forRoot(config);
  }

}
